import { render, staticRenderFns } from "./live-dianzan-canvas.vue?vue&type=template&id=d4c2e36c&scoped=true"
import script from "./live-dianzan-canvas.vue?vue&type=script&lang=js"
export * from "./live-dianzan-canvas.vue?vue&type=script&lang=js"
import style0 from "./live-dianzan-canvas.vue?vue&type=style&index=0&id=d4c2e36c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.24_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_esdk3aqwspx5xq2g2xm6lubema/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c2e36c",
  null
  
)

export default component.exports